import React from 'react';
import styled from 'styled-components';
import { EmailOutlined, SupportAgentOutlined, BusinessOutlined } from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
`;

const Heading = styled.h1`
  text-align: center;
  margin-bottom: 40px;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const IconWrapper = styled.div`
  font-size: 3rem;
  color: #007bff;
  margin-bottom: 15px;
`;

const ContactCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 25px;
  text-align: center;

  h2 {
    margin-top: 0;
    font-size: 1.5rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.5;
  }

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: bold;
  }
`;

const Contact = () => {
  return (
    <PageContainer>
      <Heading>Contact Us</Heading>
      <p style={{textAlign: 'center', marginBottom: '40px'}}>We're here to help. Reach out to us through any of the channels below.</p>
      <ContactGrid>
        <ContactCard>
          <IconWrapper><EmailOutlined fontSize="inherit" /></IconWrapper>
          <h2>General Inquiries</h2>
          <p>For general questions about DevOps Buddy or Vaidhyamegha Pvt. Ltd., please email us.</p>
          <a href="mailto:info@vaidhyamegha.com">info@vaidhyamegha.com</a>
        </ContactCard>
        <ContactCard>
          <IconWrapper><SupportAgentOutlined fontSize="inherit" /></IconWrapper>
          <h2>Technical Support</h2>
          <p>Need help with our platform? Our support team is ready to assist you with any technical issues.</p>
          <a href="mailto:support@vaidhyamegha.com">support@vaidhyamegha.com</a>
        </ContactCard>
        <ContactCard>
          <IconWrapper><BusinessOutlined fontSize="inherit" /></IconWrapper>
          <h2>Mailing Address</h2>
          <p>Vaidhyamegha Pvt. Ltd.<br/>123 Tech Park Avenue<br/>Silicon Valley, CA 94043<br/>USA</p>
        </ContactCard>
      </ContactGrid>
    </PageContainer>
  );
};

export default Contact;
